import { IconCustomerInfo, IconDateAndTime, IconDetails, IconLocation, IconQuestions, IconService, IconServiceType, IconSetAppointment } from 'assets/icons';

export const journeyTypes = {
    journey: 1,
    reschedule: 2,
    quickReschedule: 3
}
const journeyStepEnum = {
    stepCustomerIdentification: 1, 1: 'stepCustomerIdentification',
    stepServiceType: 2, 2: 'stepServiceType',
    stepLocation: 3, 3: 'stepLocation',
    stepService: 4, 4: 'stepService',
    stepDateAndTime: 5, 5: 'stepDateAndTime',
    stepDetails: 6, 6: 'stepDetails',
    stepSetAppointment: 7, 7: 'stepSetAppointment',
    stepQuestions: 12, 12: 'stepQuestions',
}

const rescheduleStepEnum = {
    stepCustomerIdentificationReschedule: 13, 13: 'stepCustomerIdentificationReschedule',
    stepAppointmentDetailsReschedule: 14, 14: 'stepAppointmentDetailsReschedule',
    stepQuestionReschedule: 16, 16: 'stepQuestionReschedule',
    stepDateAndTimeReschedule: 17, 17: 'stepDateAndTimeReschedule',
    stepSetAppointmentReschedule: 18, 18: 'stepSetAppointmentReschedule',
}

const quickRescheduleStepEnum = {
    errorPage: 24, 24: 'errorPage ',
    stepCustomerIdentificationQuickReschedule: 22, 22: 'stepCustomerIdentificationQuickReschedule',
    stepQuestionQuickReschedule: 25, 25: 'stepQuestionQuickReschedule',
    stepDateAndTimeQuickReschedule: 26, 26: 'stepDateAndTimeQuickReschedule',
    stepSetAppointmentQuickReschedule: 27, 27: 'stepSetAppointmentQuickReschedule',
    stepAppointmentDetailsQuickReschedule: 28, 28: 'stepAppointmentDetailsQuickReschedule',
}

export const stepTypeEnum = { ...journeyStepEnum, ...rescheduleStepEnum, ...quickRescheduleStepEnum };

export const defaultStepPropertyTypeListEnum = {
    newCustomer: 1, 1: 'newCustomer',
    verification: 2, 2: 'verification',
    customerIdType: 3, 3: 'customerIdType',
    location: 4, 4: 'location',
    serviceType: 5, 5: 'serviceType',
    appointmentType: 6, 6: 'appointmentType',
    services: 7, 7: 'services',
    calendar: 8, 8: 'calendar',
    rangeTime: 9, 9: 'rangeTime',
    timeSlots: 10, 10: 'timeSlots',
    setAppointment: 11, 11: 'setAppointment',
    success: 12, 12: 'success',
    details: 19, 19: 'details',
    cancelMessage: 20, 20: 'cancelMessage',
    cancelSuccess: 21, 21: 'cancelSuccess',
    question: 22, 22: 'question',
    appointmentDetails: 23, 23: 'appointmentDetails',
    errors: 25, 25: 'errors',
    successReschedule: 26, 26: 'successReschedule',
    successQuickReschedule: 28, 28: 'successQuickReschedule',
    defaultQuestion: 29, 29: 'defaultQuestion',
}

export const questionTypeEnum = {
    singleSelection: 22, 22: 'singleSelection',
    multiSelection: 27, 27: 'multiSelection',
    freeText: 28, 28: 'freeText',
}

export const identityTypeEnum = {
    regularJourney: 1,
    deepLinkJourney: 2,
    1: 'regularJourney',
    2: 'deepLinkJourney',
}

export const defaultSubStepPropertyTypeEnum = {
    stepSuccess: 8, 8: 'stepSuccess',
    stepVerificationOtp: 9, 9: 'stepVerificationOtp',
    stepNewCustomer: 10, 10: 'stepNewCustomer',
    stepCancelAppointment: 11, 11: 'stepCancelAppointment',
    stepCancelAppointmentReschedule: 15, 15: 'cancellingOptionReschedule',
    stepSuccessReschedule: 19, 19: 'successReschedule',
    stepSuccessQuickReschedule: 28, 28: 'stepSuccessQuickReschedule',
    stepCancelAppointmentReschedule1: 20, 20: 'cancellingOption1Reschedule',
    stepVerificationOtpReschedule: 21, 21: 'stepVerificationOtpReschedule',
    stepVerificationOtpQuickReschedule: 23, 23: 'stepVerificationOtpQuickReschedule',
    stepCancelAppointmentQuickReschedule: 29, 29: 'stepCancelAppointmentQuickReschedule',
};

export const propertyList = {
    cp: 17, 17: 'cp',
    ccp: 18, 18: 'ccp'
}

export const PropertyCcpInputTypeListEnum = {
    Text: 0, 0: "Text",
    Flag: 1, 1: "Flag",
    List: 2, 2: "List",
    Date: 3, 3: "Date",
    MultiLineText: 4, 4: "MultiLineText"
};


export const PropertyCpInputTypeListEnum = {
    extRef: 1, 1: "extRef",
    firstName: 2, 2: "firstName",
    lastName: 3, 3: "lastName",
    email: 4, 4: "email",
    telNumber1: 5, 5: "telNumber1",
    telNumber2: 6, 6: "telNumber2",
    dob: 7, 7: "dob",
    gender: 8, 8: "gender",
    notificationConsent: 9, 9: "notificationConsent",
    CustomerPicture: 10, 10: "CustomerPicture",
    languageCode: 11, 11: "languageCode"
};

export const datesIdentificators = {
    cpDate: `${propertyList.cp}_${PropertyCpInputTypeListEnum.dob}`,
    ccpDate: `${propertyList.ccp}_${PropertyCcpInputTypeListEnum.Date}`
}

export const messageType = {
    information: 0,
    success: 1,
    warning: 2,
    error: 3,
    0: 'information',
    1: 'success',
    2: 'warning',
    3: 'error'
}

const userDataByStepsJourney = {
    stepCustomerIdentification: "hasCustomer",
    stepLocation: "location",
    stepServiceType: "serviceType",
    stepService: "service",
    stepDateAndTime: "dateAndTime",
    stepQuestions: "questions"
}

const userDataByStepsReschedule = {
    stepCustomerIdentificationReschedule: "hasCustomer",
    stepDateAndTimeReschedule: "dateAndTime",
    stepQuestionReschedule: "questions",
    stepAppointmentDetailsReschedule: "appointmentDetails"
}

const userDataByStepsQuickReschedule = {
    stepCustomerIdentificationQuickReschedule: "hasCustomer",
    stepDateAndTimeQuickReschedule: "dateAndTime",
    stepQuestionQuickReschedule: "questions",
    stepAppointmentDetailsQuickReschedule: "appointmentDetails"
}

export const userDataBySteps = { ...userDataByStepsJourney, ...userDataByStepsReschedule, ...userDataByStepsQuickReschedule };

export const generalStepPropertyTypeListEnum = {
    label: 13, 13: 'label',
    warning: 14, 14: 'warning',
    information: 15, 15: 'information',
    header: 16, 16: 'header',
    link: 24, 24: 'link',
    question: 22, 22: 'question',
    multiSelection: 27, 27: 'multiSelection',
    freeText: 28, 28: 'freeText',
    defaultQuestion: 29, 29: 'defaultQuestion',
}

const journeyStepTypeIcon = {
    [stepTypeEnum.stepCustomerIdentification]: <IconCustomerInfo />,
    [stepTypeEnum.stepServiceType]: <IconServiceType />,
    [stepTypeEnum.stepLocation]: <IconLocation />,
    [stepTypeEnum.stepService]: <IconService />,
    [stepTypeEnum.stepDateAndTime]: <IconDateAndTime />,
    [stepTypeEnum.stepDetails]: <IconDetails />,
    [stepTypeEnum.stepSetAppointment]: <IconSetAppointment />,
    [stepTypeEnum.stepQuestions]: <IconQuestions />
}

const rescheduleStepTypeIcon = {
    [stepTypeEnum.stepCustomerIdentificationReschedule]: <IconCustomerInfo />,
    [stepTypeEnum.stepDateAndTimeReschedule]: <IconDateAndTime />,
    [stepTypeEnum.stepAppointmentDetailsReschedule]: <IconSetAppointment />,
    [stepTypeEnum.stepQuestionReschedule]: <IconQuestions />,
    [stepTypeEnum.stepSetAppointmentReschedule]: <IconSetAppointment />,
}

const quickRescheduleStepTypeIcon = {
    [stepTypeEnum.stepCustomerIdentificationQuickReschedule]: <IconCustomerInfo />,
    [stepTypeEnum.stepAppointmentDetailsQuickReschedule]: <IconSetAppointment />,
    [stepTypeEnum.stepQuestionQuickReschedule]: <IconQuestions />,
    [stepTypeEnum.stepDateAndTimeQuickReschedule]: <IconDateAndTime />,
    [stepTypeEnum.stepSetAppointmentQuickReschedule]: <IconSetAppointment />,
    [stepTypeEnum.errorPage]: <IconQuestions />,
}

export const StepTypeIcon = { ...journeyStepTypeIcon, ...rescheduleStepTypeIcon, ...quickRescheduleStepTypeIcon };